import React, { useEffect, useState } from 'react'
import {
  Col,
  Form,
  notification,
  Row,
  Select as SelectAntd,
  TreeSelect
} from 'antd'
import { FormikProps } from 'formik'
import { TreeNode } from 'antd/lib/tree-select/interface'
import { useTranslation } from 'react-i18next'

import { AssignTree, UserLevel } from 'src/types'
import { Input, Select } from 'src/components/Formik'
import { Option } from 'src/components/Formik/Select'
import * as TreesService from 'src/services/api/trees'

import { InitialValues } from '../initial-values'

const userLevels: Option[] = [
  {
    label: 'Admin',
    title: 'Admin',
    value: UserLevel.Admin
  },
  {
    label: 'Super admin',
    title: 'Super admin',
    value: UserLevel.SuperAdmin
  },
  {
    label: 'Usuário',
    title: 'Usuário',
    value: UserLevel.User
  }
]

interface Props {
  formikProps: FormikProps<InitialValues>
  loadingTrees: boolean
  mapTreeRecursive(item: AssignTree): TreeNode
  trees: AssignTree[]
}

export default function UserAssignments({
  formikProps,
  loadingTrees,
  mapTreeRecursive,
  trees
}: Props) {
  const [sufix, setSufix] = useState<string[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    let isSubscribed = true
    if (!formikProps.values.user_trees?.[0]?.parent_id) {
      return
    }

    setIsLoading(true)
    TreesService.getSufix({
      assign_tree_id: +formikProps.values.user_trees[0].parent_id
    })
      .then(response => {
        if (isSubscribed) {
          if (response.data) {
            setSufix(response.data)

            if (response.data[0]) {
              formikProps.setFieldValue('login_sufix', response.data[0])
            }
            return
          }
          notification.warning({
            duration: 10,
            message: t('common.response.unexpected-error'),
            placement: 'bottomRight'
          })
        }
      })
      .catch(response => {
        notification.warning({
          duration: 10,
          message: t('common.response.unexpected-error'),
          placement: 'bottomRight'
        })
      })
      .finally(() => {
        if (isSubscribed) {
          setIsLoading(false)
        }
      })
    return () => {
      isSubscribed = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formikProps.values.user_trees])

  return (
    <>
      <Row gutter={24}>
        <Col span={6}>
          <Select
            dataTestId="user-level-type-list"
            formikProps={formikProps}
            label="web.user.common.user-type.title"
            name="user_trees.0.user_level_group_trees.0.user_level_type"
            options={userLevels}
          />
        </Col>
        <Col span={6}>
          <Form.Item
            colon={false}
            hasFeedback
            label={t('web.policies-flow.type.hierarchy')}
            required
          >
            <TreeSelect
              loading={loadingTrees}
              onSelect={value => {
                formikProps.setFieldValue(
                  'user_trees.0.parent_id',
                  `${value.value}`
                )
              }}
              searchPlaceholder={t('web.resources.currencies.name-search')}
              showArrow
              showSearch={false}
              size="large"
              style={{ width: '100%' }}
              treeCheckable
              treeCheckStrictly
              treeData={trees.map(mapTreeRecursive)}
              treeDefaultExpandAll
              value={{
                // @ts-ignore
                value: formikProps.values.user_trees[0]
                  ? formikProps.values.user_trees[0].parent_id
                  : []
              }}
            />
          </Form.Item>
        </Col>
        <Col span={10}>
          <Input
            addonAfter={
              <SelectAntd
                disabled={!sufix.length}
                loading={isLoading}
                style={{ width: 140 }}
                value={formikProps.values.login_sufix}
              >
                {sufix.map(sufixItem => (
                  <SelectAntd.Option key={sufixItem} value={sufixItem}>
                    {sufixItem}
                    .com.br
                  </SelectAntd.Option>
                ))}
              </SelectAntd>
            }
            autoFocus
            disabled={!sufix.length}
            formikProps={formikProps}
            label="web.login.username.title"
            name="login_splited"
          />
        </Col>
      </Row>
    </>
  )
}
